import React from 'react'
import { Provider } from './Context'
import AllTemplate from './allTemplates'
import FavoriteList from './favorites'
import { Col, Row } from 'react-bootstrap'

export const ReportList = ({ reportTemplateCategories, reportFilters, appName }) => {
  return (
    <Provider reportTemplateCategories={reportTemplateCategories} appName={appName} reportFilters={reportFilters}>
      <Row>
        <Col md={8}>
          <AllTemplate />
        </Col>
        <Col md={4}>
          <FavoriteList />
        </Col>
      </Row>
    </Provider>
  )
}
